import { QueryClient } from "@tanstack/react-query";
import { COLLECTIONS_WAITING_FOR_PUBLISH_QUERY_KEY } from "components/hooks/useNumberOfCollectionsWaitingForPublish";

/**
 * For mutations that can move a collection in or out of the publishing queue:
 * the lists and the waiting-for-publish count must refresh together, or the
 * badge disagrees with the tab it sits on. Only the lists are awaited - a
 * failing count retries with backoff and must not hold the mutation pending.
 */
const refetchCollectionQueries = (queryClient: QueryClient) => {
  queryClient.refetchQueries({
    queryKey: COLLECTIONS_WAITING_FOR_PUBLISH_QUERY_KEY,
  });
  return queryClient.refetchQueries({ queryKey: ["collections"] });
};

export default refetchCollectionQueries;
